export class ExportState {
  /**
   *
   * @type {boolean}
   */
  isExporting = false;

  /**
   * Server side variables
   * @type {ExportServerConfig}
   */
  config;

  /**
   * backup of window.exportReady- useful for debugging
   * @type {boolean}
   */
  exportReady = false;

  /**
   * Widgets keyed on their ID that have been moved into summary grids
   * but we need to leave behind a message to say where it's gone
   * @type {{}}
   */
  ghostWidgets = {};

  /**
   * Widgets keyed on their layout that need to be appended
   * @type {{}}
   */
  paginatedWidgets = {};
}
